/** Stable export section catalog shared with the backend InvestigationExportSection enum. */

export const EXPORT_TOOLS = [
  {
    id: 'securitytrails',
    label: 'SecurityTrails',
    sections: [
      { id: 'whois_current', label: 'Current WHOIS' },
      { id: 'nameservers', label: 'Nameservers' },
      { id: 'a_records', label: 'A Records' },
      { id: 'aaaa_records', label: 'AAAA Records' },
      { id: 'soa', label: 'SOA' },
      { id: 'txt', label: 'TXT' },
      { id: 'mx', label: 'MX' },
      { id: 'subdomains', label: 'Subdomains' },
      { id: 'domains_on_ip', label: 'Domains on Same IP' },
      { id: 'domains_on_ns', label: 'Domains on Same NS' },
    ],
  },
  {
    id: 'securitytrails_historical',
    label: 'SecurityTrails (Historical)',
    sections: [
      { id: 'historical_whois', label: 'Historical WHOIS' },
      { id: 'historical_dns_a', label: 'Historical A' },
      { id: 'historical_dns_aaaa', label: 'Historical AAAA' },
      { id: 'historical_dns_mx', label: 'Historical MX' },
      { id: 'historical_dns_ns', label: 'Historical NS' },
      { id: 'historical_dns_soa', label: 'Historical SOA' },
      { id: 'historical_dns_txt', label: 'Historical TXT' },
    ],
  },
  {
    id: 'urlscan',
    label: 'URLScan',
    sections: [
      { id: 'urlscan_http', label: 'Http' },
      { id: 'urlscan_domains', label: 'Domains' },
      { id: 'urlscan_links', label: 'Links' },
      { id: 'urlscan_screenshot', label: 'Screenshot' },
      { id: 'urlscan_search', label: 'Search' },
    ],
  },
  {
    id: 'publicwww',
    label: 'PublicWWW',
    sections: [{ id: 'publicwww_websites', label: 'Websites' }],
  },
  {
    id: 'crtsh',
    label: 'CRT.sh',
    sections: [{ id: 'certificates', label: 'Certificates' }],
  },
  {
    id: 'findings',
    label: 'Findings',
    sections: [{ id: 'manual_findings', label: 'Findings' }],
  },
];

export function allExportSectionIds() {
  return EXPORT_TOOLS.flatMap((tool) => tool.sections.map((s) => s.id));
}

export function buildDefaultSectionSelection() {
  const selected = {};
  for (const id of allExportSectionIds()) {
    selected[id] = true;
  }
  return selected;
}

export function selectedSectionIds(selection) {
  return allExportSectionIds().filter((id) => selection[id]);
}

export function toolSelectionState(tool, selection) {
  const ids = tool.sections.map((s) => s.id);
  const checkedCount = ids.filter((id) => selection[id]).length;
  return {
    checked: checkedCount === ids.length && ids.length > 0,
    indeterminate: checkedCount > 0 && checkedCount < ids.length,
  };
}

export function setToolSections(selection, tool, checked) {
  const next = { ...selection };
  for (const section of tool.sections) {
    next[section.id] = checked;
  }
  return next;
}
